import { ChevronStrokeIcon } from '@/components/common/icon';

/** Figma 2455:24663: centered 10×5 chevron inside a 20px canvas. */
export default function CreatorAudienceCollapseChevron({
  className = ''
}: {
  className?: string;
}) {
  return (
    <span
      aria-hidden="true"
      data-testid="audience-collapse-chevron"
      className={`flex h-5 w-5 flex-shrink-0 items-center justify-center text-[#A9A29D] transition-transform motion-reduce:transition-none ${className}`}
    >
      {/* Reuse the tight 7.5×4.5 viewport at 5/3 scale: 6×3 path → 10×5,
          1 SVG-unit stroke → the design's 1.66667px rendered stroke. */}
      <ChevronStrokeIcon
        direction="up"
        className="block h-[7.5px] w-[12.5px] [&_path]:[stroke-width:1]"
      />
    </span>
  );
}
